// frontend/ConnectSea-WEB/src/app/shared/components/footer/footer.component.ts
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ThemeService } from 'src/app/shared/services/theme.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false, // Mantendo como você pediu
})
export class FooterComponent implements OnInit {
  // Define se vai exibir os links extras e ter opacidade maior
  @Input() isLoginMode: boolean = false;

  tenantName$: Observable<string>;

  constructor(private themeService: ThemeService) {
    this.tenantName$ = this.themeService.tenantName$;
  }

  ngOnInit(): void {}
}
